export interface SyncEntity {
  state: SyncEntityState;
}

export enum SyncEntityState {
  Synced = 0,
  ToCreate = 1,
  ToUpdate = 2,
  ToDelete = 3,
  Failed = 4,
}
